declare const REGION: string;

export const useCnSite = () => {
  const cnEdition = REGION === 'CN';

  return {
    cnEdition,
  };
};
